module.exports = __webpack_public_path__ + "img/lxwm.6125515.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/trait/lxwm.png
// module id = QY9Q
// module chunks = 24